import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import style from './index.module.scss';
import { MENU_STICKY } from '@lib/constants';
import { MENU_OFFCANVAS } from '@lib/constants';

export default function MenuBtn({ menuState, currentMenuState }) {
	const { isOnline } = useSelector((state) => state.user);

	const toggleState = () => {
		menuState(!currentMenuState);
	};

	useEffect(() => {
		const handleResize = () => {
			if (document.body.clientWidth > 768 && currentMenuState) {
				menuState(false);
			}
		};

		const handleKeyDown = (event) => {
			if (event.key === 'Escape' && currentMenuState) {
				menuState(false);
			}
		};

		window.addEventListener('resize', handleResize);
		document.addEventListener('keydown', handleKeyDown);

		return () => {
			window.removeEventListener('resize', handleResize);
			document.removeEventListener('keydown', handleKeyDown);
		};
	}, [currentMenuState, menuState]);

	if (!isOnline) return null;

	return (
		<button
			className={`hamburger ${style.wrapper} ${currentMenuState && style.isClicked} ${
				MENU_OFFCANVAS && style.offCanvas
			}`}
			onClick={toggleState}
		>
			<>
				<div className={style.MenuAction}>
					<span className={style.menu}>Menu</span>
					<span className={style.close}>Close</span>
				</div>
				<div className={`hamburger__bun ${style.bun}`}>
					<div className={`hamburger__burger ${style.burger}`}></div>
				</div>
			</>
			<span className="is-sr-only">Toggle mobile menu</span>
		</button>
	);
}
